// alertifySetup.js
// Alertify.js'i uygulama genelinde BİR KEZ yapılandırır: CSS'i içe aktarır, toast'ları
// sayfanın altına konumlandırır, buton metinlerini Türkçeleştirir. Bu dosyayı nereden
// import edersen et (ShogiGame.jsx, AuthControls.jsx, ...), hep aynı yapılandırılmış
// `alertify` nesnesini alırsın — CSS/ayarları tekrar tekrar import etmene gerek yok.
//
// ÖNEMLİ: Bu dosya en az bir kez, uygulama en baştan yüklenirken import edilmeli
// (ShogiApp.jsx'te yapılıyor) — yoksa kullanıcı hiç /oyna sayfasına gitmeden bir yerde
// alertify bildirimi tetiklenirse (ör. Navbar'daki giriş hatası) CSS henüz yüklenmemiş
// olabilir ve bildirim biçimsiz görünür.

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';

alertify.set('notifier', 'position', 'bottom-center');
alertify.set('notifier', 'delay', 4);
alertify.defaults.glossary.ok = 'Evet';
alertify.defaults.glossary.cancel = 'Hayır';

export default alertify;
